<template>
  <div class="relative">
    <Transition name="fade-swap" mode="out-in">
      <div v-if="loading" key="loading">
        <LoadingState
          v-if="showMessage"
          message="Se încarcă produsele..."
          hint="Poate dura câteva secunde dacă conexiunea este lentă"
        />
        <div
          class="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
          :class="{ '-mt-4': showMessage }"
        >
          <ProductCardSkeleton
            v-for="i in skeletonCount"
            :key="i"
          />
        </div>
      </div>

      <div v-else-if="!products.length" key="empty" class="py-16 text-center">
        <UIcon name="i-heroicons-magnifying-glass" class="mx-auto mb-4 h-16 w-16 text-dimmed" />
        <h2 class="mb-2 text-lg font-medium text-highlighted">Niciun produs găsit</h2>
        <p class="text-muted">Încercați să modificați filtrele sau termenii de căutare.</p>
      </div>

      <div v-else key="grid" class="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <ProductCard
          v-for="(product, index) in products"
          :key="product.id"
          :product="product"
          :priority="index === 0 ? 'high' : index < 4 ? 'eager' : false"
          :reveal-delay="staggerDelay(index)"
        />

        <template v-if="loadingMore">
          <ProductCardSkeleton
            v-for="i in loadMoreSkeletonCount"
            :key="`more-${i}`"
          />
        </template>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '~/types'

withDefaults(defineProps<{
  products: Product[]
  loading?: boolean
  loadingMore?: boolean
  skeletonCount?: number
  loadMoreSkeletonCount?: number
  showMessage?: boolean
}>(), {
  loading: false,
  loadingMore: false,
  skeletonCount: 16,
  loadMoreSkeletonCount: 4,
  showMessage: true,
})

const { storefrontStaggerGrid } = useSiteSettings()

function staggerDelay(index: number) {
  if (!storefrontStaggerGrid.value) return false
  return Math.min(index, 15) * 50
}
</script>
